import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["sv"],
  defaultLocale: "sv",
  localePrefix: "always"
});
